// extracted by mini-css-extract-plugin
export default {"root":"InvitationRoute_root__+HgIK","header":"InvitationRoute_header__3vvLs","form-container":"InvitationRoute_form-container__esdno","footer":"InvitationRoute_footer__gh+wt"};